import {
  IconButton as ChakraIconButton,
  IconButtonProps as ChakraIconButtonProps,
  PlacementWithLogical,
  Tooltip,
} from '@chakra-ui/react';
import { IconContext } from '@gamma/icons';
import { ReactNode, forwardRef } from 'react';

export interface IconButtonProps extends ChakraIconButtonProps {
  onTooltipOpen?: () => void;
  onTooltipClose?: () => void;
  tooltipOpenDelay?: number;
  tooltipCloseDelay?: number;
  tooltipPlacement?: PlacementWithLogical;
  tooltipHasArrow?: boolean;
  tooltip?: ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  variant?: string;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      onTooltipClose,
      onTooltipOpen,
      tooltipCloseDelay,
      tooltipOpenDelay,
      tooltipPlacement,
      tooltipHasArrow = true,
      tooltip,
      size,
      variant,
      ...buttonProps
    },
    ref,
  ) => {
    return (
      <Tooltip
        onClose={onTooltipClose}
        onOpen={onTooltipOpen}
        closeDelay={tooltipCloseDelay}
        openDelay={tooltipOpenDelay}
        placement={tooltipPlacement}
        isDisabled={tooltip === undefined}
        label={tooltip}
        shouldWrapChildren={buttonProps.isDisabled}
        hasArrow={tooltipHasArrow}
      >
        <IconContext.Provider value={{ size: size || 'md' }}>
          <ChakraIconButton
            size={`box-${size}`}
            variant={variant?.split(' ')[0]}
            {...buttonProps}
            {...(variant?.endsWith(' round') && { borderRadius: 'full' })}
            ref={ref}
          />
        </IconContext.Provider>
      </Tooltip>
    );
  },
);
